module.exports = __webpack_public_path__ + "static/img/logo.46f23fe8.png";